// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainPrimaryButton_container__32mkr","label":"PlainPrimaryButton_label__2diev"};